export default __webpack_public_path__ + "static/media/landing_pic.55e669de.png";